export const filmProfile = {
  name: "漂亮的小姨子",
  tagline: "一场藏在亲情缝隙里的情感拉扯，把三个人的选择推上同一张餐桌。",
  intro:
    "《漂亮的小姨子》是一部围绕都市家庭关系展开的家庭伦理剧情片。故事从妹妹苏念搬进姐姐家帮忙照顾生下孩子不久的姐姐开始，日常的柴米油盐被拉长成一条细细的裂缝，责任、愧疚与克制轮流上桌。影片不靠激烈冲突取胜，而是把镜头停在一顿饭、一次沉默和一句没说完的话上，让观众自己判断谁对谁错。",
  facts: [
    { label: "片名", value: "漂亮的小姨子" },
    { label: "类型", value: "家庭伦理 / 都市情感 / 剧情" },
    { label: "制片地区", value: "中国大陆" },
    { label: "首映年份", value: "2019" },
    { label: "片长", value: "96 分钟" },
    { label: "语言", value: "汉语普通话" },
    { label: "导演", value: "林致远" },
    { label: "编剧", value: "苏晚、陈亦宁" },
    { label: "出品", value: "江河映画" },
    { label: "叙事结构", value: "线性叙事 · 三段式分幕" },
  ],
};

export const quickStats = [
  { icon: "ri-film-line", label: "作品类型", value: "家庭伦理片" },
  { icon: "ri-time-line", label: "总片长", value: "96 分钟 · 三幕" },
  { icon: "ri-team-line", label: "主要角色", value: "6 位核心人物" },
  { icon: "ri-chat-quote-line", label: "影迷短评", value: "收录 4 条观点" },
];

export const plotSections = [
  {
    id: "plot-setup",
    act: "第一幕 · 搬进姐姐家",
    title: "日常被摊开，裂缝从一杯温牛奶开始",
    paragraphs: [
      "苏念刚辞职，姐姐苏晴又赶上产后最狼狈的一段时间。母亲一句“你去帮帮忙”把她推进了姐姐家的两居室，也推进了姐夫陈立的日常半径。镜头先给的是秩序：几点喂奶、几时买菜、谁洗碗、谁哄孩子，所有人都在自己的格子里，客气得像合租的陌生人。",
      "改变发生在很小的细节里。陈立加班回家，餐桌上总留着一碗热汤；苏念熬夜改简历，客厅的灯不会先灭。这些照顾落在旁人眼里是体贴，落在当事人心里却慢慢变了味道——不是心动，而是“原来还有人记得我”。",
    ],
  },
  {
    id: "plot-turn",
    act: "第二幕 · 说不出口的东西",
    title: "没人越界，但界线每天都在挪",
    paragraphs: [
      "姐姐苏晴是家里最清醒也最疲惫的人。她把妹妹的帮忙当成理所当然，也把丈夫的沉默理解成工作压力。三个人坐在同一张餐桌上，谁都知道有些话不该问，却又谁都在用沉默回答。",
      "影片高明的部分在于它从不给“出轨”的戏剧性镜头。最接近失控的一场戏，是夜里停电，两个人隔着半扇门借一只打火机；火光只亮了两秒，两个人却都看清了对方眼里的犹豫。这种克制，比任何争吵都更让人心里发紧。",
    ],
  },
  {
    id: "plot-choice",
    act: "第三幕 · 各归各位",
    title: "真正的和解，是把话摊开说",
    paragraphs: [
      "转折来自姐姐的一次爆发。她没有指责任何人，只是把这段时间憋着的话一口气说完：她不是没看见，她只是太累了。这场戏之后，故事没有走向撕破脸，而是走向一次重新分工的晚餐。",
      "结局里苏念搬出了姐姐家，在一家小公司重新开始；陈立开始学着自己哄孩子；苏晴重新拿起了搁置很久的画笔。三个人没有互相原谅什么天大的过错，只是把彼此的位置重新摆正。影片最后定格在一扇被擦得很亮的窗户上——看得到自己，也看得到外面。",
    ],
  },
];

export const characters = [
  {
    name: "苏念",
    role: "妹妹 · 小姨子",
    trait: "温和、敏感、习惯先照顾别人",
    relation: "与姐姐苏晴相差六岁，辞职后暂住姐姐家帮忙",
    desc: "她是全片的视角中心。因为从小活在姐姐的影子里，她格外在意“被需要”的感觉。她并不想破坏什么，只是太久没被认真地看见过。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20cinematic%20illustration%20portrait%20of%20a%20thoughtful%20young%20Chinese%20woman%20wearing%20a%20soft%20beige%20knit%20sweater%2C%20warm%20amber%20side%20lighting%2C%20muted%20terracotta%20and%20cream%20tones%2C%20clean%20minimal%20warm%20studio%20background%2C%20editorial%20film%20character%20key%20art%2C%20gentle%20quiet%20expression%2C%20high%20detail%2C%20harmonious%20composition&width=600&height=750&seq=film-char-nian-01&orientation=portrait",
  },
  {
    name: "陈立",
    role: "姐夫",
    trait: "内敛、责任感重、不擅表达",
    relation: "苏晴的丈夫，建筑设计师，长期加班",
    desc: "他的沉默既是宽容也是逃避。剧本刻意不给他的心动任何特权，只让观众看到一个大人在疲惫里如何一寸寸失去边界感。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20cinematic%20illustration%20portrait%20of%20a%20calm%20reserved%20Chinese%20man%20in%20his%20thirties%20wearing%20a%20simple%20dark%20shirt%2C%20soft%20warm%20amber%20lighting%2C%20muted%20brown%20and%20cream%20tones%2C%20clean%20minimal%20warm%20studio%20background%2C%20editorial%20film%20character%20key%20art%2C%20thoughtful%20serious%20expression%2C%20high%20detail%2C%20harmonious%20composition&width=600&height=750&seq=film-char-li-01&orientation=portrait",
  },
  {
    name: "苏晴",
    role: "姐姐 · 苏念之姐",
    trait: "清醒、要强、把疲惫藏得很深",
    relation: "陈立的妻子，产后复工的杂志编辑",
    desc: "她不是被蒙在鼓里的弱者，恰恰相反，她最早察觉到了空气里的变化，只是选择了暂时不说。全片最有力量的一段独白属于她。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20cinematic%20illustration%20portrait%20of%20a%20poised%20expressive%20Chinese%20woman%20in%20her%20thirties%20wearing%20a%20muted%20rust%20blouse%2C%20warm%20golden%20lighting%2C%20terracotta%20and%20cream%20color%20palette%2C%20clean%20minimal%20warm%20studio%20background%2C%20editorial%20film%20character%20key%20art%2C%20determined%20melancholic%20expression%2C%20high%20detail%2C%20harmonious%20composition&width=600&height=750&seq=film-char-qing-01&orientation=portrait",
  },
  {
    name: "周叙",
    role: "邻居 · 旧同学",
    trait: "直率、热心、喜欢把话挑明",
    relation: "与苏念是大学同学，住同一栋楼",
    desc: "他是影片里唯一的“外部视角”，负责替观众把那些说不出口的话问出来，也负责提醒苏念：有些照顾不是爱，只是习惯。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20cinematic%20illustration%20portrait%20of%20a%20friendly%20cheerful%20young%20Chinese%20man%20wearing%20a%20casual%20light%20jacket%2C%20soft%20warm%20daylight%2C%20muted%20olive%20and%20cream%20tones%2C%20clean%20minimal%20warm%20studio%20background%2C%20editorial%20film%20character%20key%20art%2C%20open%20honest%20expression%2C%20high%20detail%2C%20harmonious%20composition&width=600&height=750&seq=film-char-xu-01&orientation=portrait",
  },
  {
    name: "陈母",
    role: "婆婆",
    trait: "传统、唠叨、刀子嘴豆腐心",
    relation: "陈立的母亲，偶尔来帮忙带孙",
    desc: "她代表的是旧式家庭的分寸观。她对苏念的到来一开始并不放心，几场看似挑剔的对话，后来成了推动三人直面彼此关系的引子。",
    image:
      "https://readdy.ai/api/search-image?query=Elegant%20stylized%20cinematic%20illustration%20portrait%20of%20a%20dignified%20older%20Chinese%20woman%20with%20grey%20hair%20in%20a%20warm%20knit%20cardigan%2C%20soft%20amber%20lighting%2C%20muted%20brown%20and%20cream%20tones%2C%20clean%20minimal%20warm%20studio%20background%2C%20editorial%20film%20character%20key%20art%2C%20stern%20warm%20expression%2C%20high%20detail%2C%20harmonious%20composition&width=600&height=750&seq=film-char-mu-01&orientation=portrait",
  },
  {
    name: "小满",
    role: "苏晴的女儿 · 婴儿",
    trait: "唯一的“无辜者”",
    relation: "陈立与苏晴的孩子，故事的时间起点",
    desc: "她的每一次哭闹都在重新分配这个家的注意力，也无意间成为三人关系变化的背景音。她不会说话，却让所有大人的话都变得很重。",
    image:
      "https://readdy.ai/api/search-image?query=Soft%20warm%20stylized%20illustration%20of%20a%20sleeping%20baby%20wrapped%20in%20a%20cream%20knit%20blanket%20in%20a%20cozy%20crib%2C%20gentle%20amber%20window%20light%2C%20muted%20terracotta%20and%20beige%20tones%2C%20clean%20minimal%20warm%20background%2C%20tender%20editorial%20composition%2C%20high%20detail%2C%20peaceful%20atmosphere&width=600&height=750&seq=film-char-baby-01&orientation=portrait",
  },
];

export const castList = [
  { actor: "沈知夏", character: "苏念", note: "凭本片获年度新人提名，表演克制而有层次" },
  { actor: "顾维安", character: "陈立", note: "擅长内敛型角色，全片台词量最少的主演" },
  { actor: "林书白", character: "苏晴", note: "第三幕独白一条过，被剪入官方预告" },
  { actor: "程屿", character: "周叙", note: "负责调节影片节奏与提供外部视角" },
  { actor: "何慧兰", character: "陈母", note: "舞台剧出身，多场对手戏以细节见长" },
  { actor: "—", character: "小满", note: "由三组婴儿演员轮流完成拍摄" },
];

export const commentaryActs = [
  {
    id: "act-1",
    label: "第一幕",
    title: "日常作为伏笔：为什么是“帮忙照顾”",
    body: [
      "很多家庭伦理片喜欢用突发事件开场，这部片子偏偏选了最普通的方式——妹妹来姐姐家帮忙。编剧用近二十分钟铺垫日常，其实是在立规矩：谁进谁的生活、谁欠谁的人情、谁有资格说累。",
      "注意一个细节：苏念第一天到，姐姐给她的是客房的钥匙；到第一幕结尾，她已经用同一把钥匙开了姐姐家的门去取快递。空间的边界一旦松动，情感的边界也就有了松动的前提。",
    ],
    highlights: [
      "开场用早餐桌站位交代三人关系：姐姐居中、姐夫靠窗、妹妹进门",
      "“热汤”在片中反复出现三次，对应三段关系的不同阶段",
      "第一幕几乎没有配乐，靠环境音放大日常的压迫感",
    ],
  },
  {
    id: "act-2",
    label: "第二幕",
    title: "克制的临界点：那只借出的打火机",
    body: [
      "第二幕是整部戏张力最足的部分，但它几乎没有任何“越界”的动作。导演把镜头对准距离：两个人站在同一盏灯下，却始终隔着一只手臂的长度。",
      "停电借火那场戏被观众反复讨论。火光只维持两秒，照亮的不是欲望，而是“我本可以”——这种未发生的可能，恰恰是伦理片最动人的地方：真正难的从来不是越线，而是在线内站住。",
    ],
    highlights: [
      "全片最长的沉默镜头长达 14 秒，出现在借火之后",
      "姐夫第一次叫全名“苏念”，预示关系的微妙位移",
      "姐姐开始减少加班，用行动而非质问应对变化",
    ],
  },
  {
    id: "act-3",
    label: "第三幕",
    title: "把话摊开：和解不是原谅，是归位",
    body: [
      "结局的处理相当反套路。没有争吵、没有揭穿、没有狗血的离开，只有一顿重新排过座位的晚饭。姐姐的独白把三个人的疲惫都认领了一遍，然后各自退回本来的位置。",
      "片尾那扇被擦亮的窗户是导演留下的注脚：和解不意味着什么都没发生，而是发生过之后，每个人都还愿意继续把日子过下去。这也是本片被称作“温和的伦理片”的原因。",
    ],
    highlights: [
      "晚餐段落用固定机位，三人坐姿重新回到片头的构图",
      "妹妹的行李箱再次出现，但这次是自己拉走的",
      "结尾无字幕台词，留白交给观众",
    ],
  },
];

export const themes = [
  {
    icon: "ri-home-heart-line",
    title: "亲情里的边界感",
    desc: "影片最核心的提问不是“有没有爱”，而是“在亲情里，照顾和靠近的边界在哪里”。它把分寸感当成主题，而不是把道德当成结论。",
  },
  {
    icon: "ri-eye-line",
    title: "被看见的渴望",
    desc: "三个成年人都处在“付出不被看见”的状态里。妹妹想被认可，姐夫想被理解，姐姐想被分担——错位需求叠在一起，才让日常变得危险。",
  },
  {
    icon: "ri-scales-3-line",
    title: "沉默的代价",
    desc: "片中每个人都在用沉默保护关系，结果沉默反而加厚了误会。影片给出的答案很朴素：很多关系的裂缝，是从“不说了”开始的。",
  },
  {
    icon: "ri-contrast-2-line",
    title: "克制的表达美学",
    desc: "没有配乐轰炸，没有强冲突，靠空间、光线和停顿讲故事。这种留白让影片在同类家庭伦理题材里显得格外克制。",
  },
];

export const reviewTags = ["全部", "剧情", "表演", "节奏", "摄影", "结局"];

export const reviews = [
  {
    user: "梧桐巷",
    score: 8.4,
    tag: "剧情",
    date: "2024-03-11",
    text: "以为是那种很吵的伦理片，结果安静得让人不敢大口喘气。前二十分钟有点慢，但看到第三幕那顿晚饭就全明白了，前面每一口汤都是伏笔。",
  },
  {
    user: "晚风抄写员",
    score: 8.0,
    tag: "表演",
    date: "2024-03-19",
    text: "女主把“懂事”演得太准了，越是不动声色越让人心疼。姐夫的角色台词少，但借火那场戏一个眼神就够了，演技派确实不一样。",
  },
  {
    user: "胶片收集者",
    score: 8.7,
    tag: "摄影",
    date: "2024-04-02",
    text: "灯光师值得一夸，全片都在暖黄和阴天之间来回切换，家里越暖，人物心里越冷。结尾那扇窗户的收尾特别妙，含蓄但有力。",
  },
  {
    user: "橘子汽水",
    score: 7.6,
    tag: "结局",
    date: "2024-04-15",
    text: "结局没有撕破脸，一开始觉得不够解气，回头想想这才是生活。不是所有关系都有明确的坏人，更多时候只是大家都累了没说出口。",
  },
  {
    user: "午夜放映室",
    score: 6.9,
    tag: "节奏",
    date: "2024-04-27",
    text: "中段铺陈稍显冗长，第二条线（邻居周叙）可以再精简一点。但整体瑕不掩瑜，属于需要静下心看的那类片子。",
  },
];

export const relatedFilms = [
  {
    title: "夏日的阳台",
    year: "2020",
    genre: "家庭剧情",
    desc: "同样以一间小房子为单位，讲一对母女在夏天里的和解与告别。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20cinematic%20poster%20of%20a%20sunlit%20old%20balcony%20with%20potted%20green%20plants%20and%20a%20light%20linen%20curtain%2C%20golden%20afternoon%20light%2C%20muted%20amber%20and%20cream%20tones%2C%20nostalgic%20quiet%20atmosphere%2C%20minimal%20editorial%20film%20art%2C%20high%20detail%2C%20harmonious%20warm%20composition&width=600&height=800&seq=film-rel-balcony-01&orientation=portrait",
  },
  {
    title: "第三人称",
    year: "2021",
    genre: "都市情感",
    desc: "三段互相咬合的关系，探讨旁观者视角下的亲密与误解。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20cinematic%20poster%20of%20an%20empty%20dining%20table%20with%20three%20chairs%20and%20a%20single%20warm%20hanging%20lamp%2C%20soft%20amber%20evening%20light%2C%20muted%20terracotta%20and%20beige%20tones%2C%20melancholic%20quiet%20atmosphere%2C%20minimal%20editorial%20film%20art%2C%20high%20detail%2C%20harmonious%20warm%20composition&width=600&height=800&seq=film-rel-third-01&orientation=portrait",
  },
  {
    title: "冬泳的人",
    year: "2022",
    genre: "现实主义",
    desc: "一个中年男人在家庭与自我之间反复沉浮的冬天。",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20stylized%20cinematic%20poster%20of%20a%20solitary%20figure%20in%20a%20thick%20coat%20beside%20a%20frosted%20window%20at%20dusk%2C%20soft%20amber%20interior%20light%2C%20muted%20brown%20and%20cream%20tones%2C%20restrained%20atmosphere%2C%20minimal%20editorial%20film%20art%2C%20high%20detail%2C%20harmonious%20warm%20composition&width=600&height=800&seq=film-rel-winter-01&orientation=portrait",
  },
];

export const faqs = [
  {
    q: "《漂亮的小姨子》讲的是一个什么故事？",
    a: "故事讲妹妹苏念在姐姐产后搬进姐姐家帮忙，与姐夫和姐姐在同一屋檐下度过一段彼此都需要被看见的日子。影片没有激烈的冲突，而是通过日常细节推进，最终走向一场把话说开的和解。",
  },
  {
    q: "这部片属于哪个类型，适合什么样的观众？",
    a: "它属于家庭伦理与都市情感题材，节奏偏慢、表达克制。更适合喜欢安静叙事、关注人物关系和细节的观众，期待强冲突或爽感反转的观众可能会觉得节奏偏缓。",
  },
  {
    q: "影片一共有几个主要角色？",
    a: "本站整理了 6 位核心人物：妹妹苏念、姐夫陈立、姐姐苏晴、邻居周叙、婆婆陈母以及苏晴的女儿小满。每一位都在片中承担明确的功能，而不是单纯的功能性配角。",
  },
  {
    q: "片名里的“小姨子”指的是谁？",
    a: "指的是妹妹苏念。她在姐姐家里既是帮手也是最边缘的那个人——这种“在场却游离”的位置，正是片名想强调的身份张力。",
  },
  {
    q: "有没有需要提前知道的观看提示？",
    a: "影片属于合规上映的家庭剧情片，内容集中在人物关系与日常对话，没有强烈刺激场面。建议在安静的环境下观看，因为很多信息藏在台词间隙和环境音里。",
  },
];